import {
  sportGamesStatusOptions,
  sportPositionValidator,
  sportStatusOptions,
} from "../sports/shared";

export const outcomeStatusOptions = sportStatusOptions;
export const outcomeGamesStatusOptions = sportGamesStatusOptions;
export const outcomePositionValidator = sportPositionValidator;

export const outcomeTypeOptions = [
  { value: 1, title: "common.types.regular" },
  { value: 2, title: "common.types.free_text" },
];

export const outcomeCompetitorTypeOptions = [
  { value: 1, title: "Team" },
  { value: 2, title: "Player" },
];
